export const scrollToListItem = (listClass: any, listItemClass: any) => {
  const list = document.querySelector(`.${listClass}`);
  const listItem = document.querySelector(`.${listItemClass}`);

  if (list && listItem) {
    return list!.scrollTo({
      top: listItem instanceof HTMLElement ? listItem?.offsetTop : 0,
      behavior: "smooth"
    });
  }
  return null;
};
